<template>
  <Report :id="id" type="provisional" audit />
</template>

<script>
import Report from "@/components/User/Fund/Report";

export default {
  components: {
    Report,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },
};
</script>
